export const SHOW_WARNING_AFTER_SECONDS = 5 * 60;
export const SALE_CLOSING_IN_SECONDS = 10 * 60;
export const MS_IN_A_SECOND = 1000;
